import { extractApiErrorMessageFromUnknown } from '@/shared/errors/api-error';

export const extractApiErrorMessage = (error: unknown): string | null => extractApiErrorMessageFromUnknown(error);
